// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import gql from 'graphql-tag';

export default gql`
  query Query($callIds: [String]!, $action: Action!, $input: String, $prompt: String, $sessionId: String) {
    queryMeetings(callIds: $callIds, action: $action, input: $input, prompt: $prompt, sessionId: $sessionId)
  }
`;
